var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2661 10.397C14.4613 10.2018 14.4613 9.88517 14.2661 9.68991C14.0708 9.49465 13.7542 9.49465 13.559 9.68991L9.98542 13.2635V0.500001C9.98542 0.223858 9.76156 5.26835e-07 9.48542 0C9.20928 1.2644e-07 8.98542 0.223858 8.98542 0.5V13.2635L5.59633 9.87437C5.40107 9.67911 5.08449 9.67911 4.88923 9.87437C4.69397 10.0696 4.69396 10.3862 4.88923 10.5815L9.13187 14.8241C9.32713 15.0194 9.64371 15.0194 9.83897 14.8241L14.2661 10.397ZM0 15.501H2V17.501H4H15H17V15.501H19V17.501C19 18.6055 18.1046 19.501 17 19.501H2C0.895432 19.501 0 18.6055 0 17.501V15.501Z",
    fill: "#0071E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.8010d069e45105e86e50e33b908c19bf.svg";
export { ForwardRef as ReactComponent };